import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material';
import { setLogout } from '../state';

const TimeoutPopup = ({ open, onClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSignIn = () => {
    // Broadcast logout event to all tabs
    localStorage.setItem('logout', Date.now());
    onClose(); // Close the popup first
    dispatch(setLogout());
    navigate('/login');
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        onClose();
      }}
      aria-labelledby="timeout-dialog-title"
      aria-describedby="timeout-dialog-description"
      disableEscapeKeyDown
    >
      <DialogTitle id="timeout-dialog-title">
        Session Timeout
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography id="timeout-dialog-description">
            Your session has expired due to inactivity. Please sign in again to continue.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSignIn} variant="contained" color="primary">
          Sign In
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TimeoutPopup; 